import React from "react";
import { MdDescription } from "react-icons/md";




const TermCondition = () => {
  return (
    <div className="pp-container">
      <div className="pp-card">

        {/* HEADER */}
        <div className="pp-header">
          <h2 className="pp-title"><MdDescription size={28} className="mb-1"/> Terms and Conditions</h2>
        </div>

        <div className="pp-body">
          <p className="pp-updated">Last Updated: April 24, 2025</p>

          <h4 className="pp-section-title">1. Welcome to CryptoApp</h4>
          <p className="pp-text">
            These Terms and Conditions ("Terms") govern your use of the CryptoApp
            platform ("Service") provided by CryptoApp Inc. By accessing or using
            the Service, you agree to be bound by these Terms. If you do not
            agree, please do not use the Service.
          </p>

          <h4 className="pp-section-title">2. Acceptance of Terms</h4>
          <p className="pp-text">
            By using CryptoApp, you confirm that you are at least 18 years old and
            have the legal capacity to enter into this agreement. We reserve the
            right to update these Terms at any time, and changes will be effective
            upon posting.
          </p>

          <h4 className="pp-section-title">3. Service Usage</h4>
          <p className="pp-text">
            You may use the Service to buy, sell, and trade cryptocurrencies. All
            transactions are subject to market conditions and network fees.
            CryptoApp is not liable for any losses due to market volatility or
            technical issues.
          </p>

          <h4 className="pp-section-title">4. Account Security</h4>
          <p className="pp-text">
            You are responsible for maintaining the confidentiality of your
            account credentials. Enable two-factor authentication (2FA) for added
            security. CryptoApp will not be liable for unauthorized access if
            proper security measures are not followed.
          </p>

          <h4 className="pp-section-title">5. Data Privacy</h4>
          <p className="pp-text">
            We collect personal data such as your name, email, and transaction
            history to provide the Service. Your data is encrypted and stored
            securely. Refer to our Privacy Policy for details on how we handle
            your information.
          </p>

          <h4 className="pp-section-title">6. Termination</h4>
          <p className="pp-text">
            We may suspend or terminate your account for violations of these
            Terms. Upon termination, you will lose access to your funds, and no
            refunds will be issued.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermCondition;
